import { ImageData } from 'constants/data';

export const filterPublishedImages = (images: ImageData[]) => {
  return images.filter(
    (image: ImageData) => image.published && !image.archived
  );
};
